import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

import { GenericdatasetSettings } from '../genericdataset/genericdataset.settings';

@Injectable()
export class UserService {
  public headers = new Headers({ 'Content-Type': 'application/json' });
  public options = new RequestOptions({ headers: this.headers });

  constructor(public http: Http) {}

  public updateProfile(item: any): Observable<any> {
    const userUrl = GenericdatasetSettings.api_endpoint + 'users/updateprofile';
    const body = JSON.stringify(item);
    return this.http.put(userUrl, body, this.options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public extractData(res: Response) {
    const body = res.json();
    return body;
  }

  public handleError(error: any) {
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return Observable.throw(errMsg);
  }

}